import navbarlinkslanding2 from "_texts/presentation/navbars/navbarlinkslanding2.js";

const textProps = {
  ...navbarlinkslanding2,
  color: "white",
};
export default textProps;
